<template>
  <div>
    <n-delete @closeModal="$modal.hide('m-delete')"
              @deleteResource="deleteBuilding({isMyOperation: true})"></n-delete>

    <div class="row">
      <div class="col">
        <div class="abtg-block-dashboard abtg-border-fat ">
          <div class="row">
            <div class="col text-center">
              <div class="abtg-badge">
                <span :data-badge="buildingCounters.analysis"
                      class="mdl-badge mdl-badge-mapping "></span>
              </div>
              <div class="abtg-badge-link">
                <a @click="setFilter(1, 'in analisi')"
                   :class="activeAnalysisLink"> {{ $t('dashboard.in_analisi') }} </a>
              </div>
              <!-- in corso -->
              <div class="abtg-badge">
                <span :data-badge="buildingCounters.inProgress"
                      class="mdl-badge mdl-badge-mapping "></span>
              </div>
              <div class="abtg-badge-link">
                <a @click="setFilter(2, 'in corso')"
                   :class="activeInProgressLink">{{ $t('dashboard.in_corso') }}</a>
              </div>
              <!-- end in corso -->

              <!-- closed -->
              <div class="abtg-badge">
                <span :data-badge="buildingCounters.closed"
                      class="mdl-badge mdl-badge-mapping "></span>
              </div>
              <div class="abtg-badge-link">
                <a @click="setFilter(3, 'chiuse')"
                   :class="activeClosedLink">{{ $t('dashboard.chiuse') }}</a>
              </div>
              <!-- end closed -->
            </div>

          </div>
        </div>
      </div>

    </div>
    <div class="card abtg__default-card abtg__default-card-border abtg__air20 ">
      <div class="card-head">
        <header class="abtg__color-black-label">{{ $t('operation.title_current_operation') }} {{ filterLabel }}
          <span class="abtg__focus-title">&nbsp;</span>
        </header>
        <div class="abtg__header_popover"></div>
        <div class="tools"></div>
      </div>
      <div class="card-body ">

        <div class="table-responsive pb-4">

          <table class="mdl-data-table ml-table-striped ml-table-bordered mdl-js-data-table   is-upgraded abtg__table-noborder"
                 style="min-height:140px;">
            <thead>
              <tr class="d-flex">
                <th class="text-left col-1">N.</th>

                <th class="mdl-data-table__cell--non-numeric text-left col-2 align-middle">

                  <span class="abtg__text-abtg">{{ $t('operation.data_importazione') }}</span>
                </th>

                <th class="mdl-data-table__cell--non-numeric text-left col-3  align-middle">
                  <span class="abtg__text-abtg">{{ $t('operation.table_starred_address') }}</span>
                </th>
                <th class="mdl-data-table__cell--non-numeric text-left col-2  align-middle">
                  <span class="abtg__text-abtg">{{ $t('operation.table_starred_city') }}</span>
                </th>

                <th class="mdl-data-table__cell--non-numeric text-left col-1  align-middle">
                  <span class="abtg__text-abtg">{{ $t('operation.overview_label_mq') }}</span>
                </th>

                <th class="col-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(u, index) in filteredBuildings"
                  class="d-flex">

                <td class="col-1 text-center">
                  {{ index + 1 }}
                </td>

                <td class="col-2 abtg-ellipsis">
                  {{ u.created_at }}
                </td>

                <td class="col-3 abtg-ellipsis">
                  <span v-if="u.broken_link === 1"
                        class="small">
                    <a style="color:red;font-size:120%;"
                       title="Annuncio non più presente sul portale">
                      <i class="fas fa-ban"></i>
                      {{ WORD_CUT(ADDRESS_REPLACE(u.via), 50) }}
                    </a>
                  </span>
                  <span v-else>
                    {{ WORD_CUT(ADDRESS_REPLACE(u.via), 50) }}
                  </span>
                  <br>
                  <a :href="u.link"
                     target="_blank"
                     style="color:#337ab7">{{whichPortal(u.link)}}</a>
                </td>
                <td class="col-2">

                  {{ u.my_city ? u.my_city.comune : '' }}<br>
                  <span v-if="u.my_zone && u.my_city">
                      <a :href="`/mapping/?cityId=${u.my_city.id}&city=${u.my_city.comune}&folderId=${u.my_zone.folder_id}#${showZoneNameHashtag(u.my_zone)}`"
                         target="_blank"
                         style="color:#337ab7">
                        <em style="font-size: 12px;">{{ showZoneName(u.my_zone) }}</em>
                      </a>
                    </span>
                </td>
                <td class="col-1">{{ u.mq }}</td>
                <td class="align-top col-3 d-flex ">
                  <a class="dropdown-item"
                     @click="createOperation({idBuilding:u.id, streetPrice: 0})">
                    <i class="fas fa-calculator  "></i>&nbsp; {{ $t('dashboard.conto_economico') }}
                  </a>&nbsp;&nbsp;

                  <div class="btn-group"
                       role="group">

                    <button class="btn btn-default shadow-none abtg__btn-tool"
                            data-toggle="modal"
                            data-target="#modalSingleMapping"
                            @click="setIdToDelete(u.id)">
                      <i class="far fa-trash-alt"></i>
                    </button>
										&nbsp;&nbsp;
                    <button id="btnGroupDrop2"
                            type="button"
                            style="margin-top: 0px;"
                            class="btn btn-default shadow-none abtg__btn-tool dropdown-toggle"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false">
											&nbsp;
                      <i class="far fa-star"></i>&nbsp;F
                    </button>

                    <div class="dropdown-menu pb-4"
                         aria-labelledby="btnGroupDrop2">
                      <a class="dropdown-item"
                         style="margin-top:5px; margin-bottom:-15px !important;text-transform:none;"
                         @click="[changeStatus({building:u, status:1, reload: true}), buildingsByStatus()]">
                        <i class="far fa-star  "></i>&nbsp; {{ $t('dashboard.in_analisi') }}
                      </a>&nbsp;&nbsp;
                      <a class="dropdown-item"
                         style="margin-bottom:-15px !important;text-transform:none;"
                         @click="[changeStatus({building:u, status:2, reload: true}), buildingsByStatus()]">
                        <i class="far fa-star  "></i>&nbsp; {{ $t('dashboard.in_corso') }}
                      </a>&nbsp;&nbsp;
                      <a class="dropdown-item"
                         data-toggle="modal"
                         data-target="#modalSingleMapping"
                         style="margin-bottom:-15px !important;text-transform:none;"
                         @click="[changeStatus({building:u, status:3, reload: true}), buildingsByStatus()]">
                        <i class="far fa-star  "></i>&nbsp; {{ $t('dashboard.chiuse') }}
                      </a>&nbsp;&nbsp;
                      <a class="dropdown-item"
                         data-toggle="modal"
                         data-target="#modalSingleMapping"
                         style="margin-bottom:-15px !important;text-transform:none;"
                         @click="[changeStatus({building:u, status:0, reload: true}), buildingsByStatus()]">
                        <i class="far fa-star"
                           style="color: transparent"></i>&nbsp; {{ $t('dashboard.nessuno') }}
                      </a>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
  import { mixin } from '@/helpers/helper'
  import NDelete from '@/partials/modal_delete'

  export default {
    components: {NDelete},
    props: ['content'],
    mixins: [mixin],
    data() {
      return {
        filter: 1,
        filterLabel: 'in analisi',
        activeClosedLink: null,
        activeInProgressLink: null,
        activeAnalysisLink: null,
        show: true,
      }
    },
    created() {
      this.buildingsByStatus()
    },
    computed: {
      ...mapState('n_dashboard', ['buildingByStatusData', 'buildingCounters']),
      ...mapState('n_mapping', []),

      filteredBuildings() {
        if (this.buildingByStatusData) {
          return this.buildingByStatusData.filter(item => parseInt(item.status) === this.filter)
        }
      },
    },
    methods: {
      ...mapMutations('n_dashboard', ['SET_DATA']),
      ...mapMutations('n_mapping', {MAPPING_SET_DATA: 'SET_DATA'}),
      ...mapActions('n_dashboard', ['buildingsByStatus']),
      ...mapActions('n_mapping', ['createOperation', 'changeStatus', 'showModal', 'deleteBuilding']),
      whichPortal(payload)
      {

        return 'link';
        // if(payload.indexOf('casa.it') > 0)
        // {
        //   return 'casa.it';
        // }
        // if(payload.indexOf('immobiliare.it') > 0)
        // {
        //   return 'immobiliare.it';
        // }
        // if(payload.indexOf('idealista.it') > 0)
        // {
        //   return 'idealista.it';
        // }
      },
      setFilter(filter, filterLabel) {
        this.filter = filter
        this.filterLabel = filterLabel
        this.show = !this.show
        this.simulateFading()
        this.activeLink()
      },
      simulateFading() {
        let self = this
        setTimeout(function() {
          self.show = !this.show
        }, 250)
      },
      resetActiveLink() {
        this.activeAnalysisLink = null
        this.activeInProgressLink = null
        this.activeClosedLink = null
      },
      activeLink() {
        let css = 'abtg-dashboard-active-link'
        switch (this.filter) {
          case 1:
            this.resetActiveLink()
            this.activeAnalysisLink = css
            break
          case 2:
            this.resetActiveLink()
            this.activeInProgressLink = css
            break
          case 3:
            this.resetActiveLink()
            this.activeClosedLink = css
            break
        }
      },

      showZoneName(z) {
        let zone = z.zone != null ? z.zone : ''
        let macrozone =	z.macrozone != null ? (z.zone != null ? ' - ' : '') + z.macrozone : ''
        let microzone = z.microzone != null ? (z.macrozone != null ? ' - ' : '') + z.microzone : ''
        let wholeZone = zone + macrozone + microzone
        if (wholeZone.length > 28) {
          return wholeZone.substr(0, 28) + '...'
        }
        return wholeZone
      },

      showZoneNameHashtag(z) {
        let zone = z.zone != null ? z.zone : ''
        let macrozone =	z.macrozone != null ? (z.zone != null ? ' - ' : '') + z.macrozone : ''
        let microzone = z.microzone != null ? (z.macrozone != null ? ' - ' : '') + z.microzone : ''
        let wholeZone = zone + macrozone + microzone

        return wholeZone.replaceAll(' ', '')
      },

      setIdToDelete(id) {
        this.MAPPING_SET_DATA({
          name: 'idToDelete', data: id
        })
        this.$modal.show('m-delete')
      },
    }
  }
</script>
